import request from './api';
import { API_SOCIAL } from '../constants/api';

export const getHomeWidgets = () => request(`${API_SOCIAL}widget/home`);
export const postWidgets = list =>
  request(`${API_SOCIAL}widget/homeuser/list`, {
    method: 'POST',
    data: list
  });
